// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__2uTaQ","approved":"Status_approved__1Qsm9","rejected":"Status_rejected__10Dzi","expired":"Status_expired__1qDnX","label":"Status_label__JKAKX"};